module.exports = __webpack_public_path__ + "static/img/Round-13-2021.a7ca5b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-13-2021.jpg
// module id = 1nta
// module chunks = 0